import { useEffect, useRef } from 'react';

const EDGE = 64;
const MAX_SPEED = 20;

const speed = distanceIntoEdge =>
    Math.ceil(((EDGE - Math.max(0, distanceIntoEdge)) / EDGE) * MAX_SPEED);

export const useDragAutoScroll = active => {
    const pointer = useRef(null);
    const rafRef = useRef(null);

    useEffect(() => {
        if (!active) return undefined;

        const onDragOver = e => {
            pointer.current = { x: e.clientX, y: e.clientY };
        };

        const tick = () => {
            const p = pointer.current;
            if (p) {
                const vh = window.innerHeight;
                if (p.y < EDGE) {
                    window.scrollBy(0, -speed(p.y));
                } else if (p.y > vh - EDGE) {
                    window.scrollBy(0, speed(vh - p.y));
                }

                const columns = document
                    .elementFromPoint(p.x, p.y)
                    ?.closest('.component-manager-columns');
                if (columns && columns.scrollWidth > columns.clientWidth) {
                    const rect = columns.getBoundingClientRect();
                    if (p.x < rect.left + EDGE) {
                        columns.scrollLeft -= speed(p.x - rect.left);
                    } else if (p.x > rect.right - EDGE) {
                        columns.scrollLeft += speed(rect.right - p.x);
                    }
                }
            }
            rafRef.current = requestAnimationFrame(tick);
        };

        window.addEventListener('dragover', onDragOver);
        rafRef.current = requestAnimationFrame(tick);

        return () => {
            window.removeEventListener('dragover', onDragOver);
            if (rafRef.current) cancelAnimationFrame(rafRef.current);
            pointer.current = null;
        };
    }, [active]);
};
